import React, { useEffect } from "react";
import result from "../../images/result.svg";
import longterm from "../../images/long-term.svg";
import heart from "../../images/heart.svg";
import medicalBriefcase from "../../images/medical-briefcase.svg";
import Compensation from "../../images/worker-c.png";
import Accommodationlrg from "../../images/Accommodation-lrg.svg";
import reports from "../../images/reports.svg";
import disability from "../../images/disability.svg";
import Assessment from "../../images/Assessment.svg";
import Asswssmentlrg from "../../images/Asswssment-lrg.svg";
import ccmService from "../../images/ccm-service.png";
import { Link } from "react-router-dom";
import LanguageConfirmationModalPopup from "../../containers/Std/LanguageConfirmationModalPopup";
import history from "../../utilities/history";
import { COMPANYID, PREFERED_LANGUAGE_KEYS } from "../../App.config";
import * as utilities from "../../utilities/utils";
import { normalizeInput } from "../../utilities/utils";
import ApplicationPending from '../../containers/PendingApplication'
import { ENGLISH, FRENCH, MODAL_SIZE, NOT_SELECTED, USER_ROLES } from "../../App.config";
import { PERMISSION_TYPE, PERMISSON_MODULES } from "../../Permission.config";
import { ShowForPermission } from "../../components/UserAuth/ShowForPermissionMenuItem";
import DisplayEmployeeName from "../../containers/DisplayEmployeeName";
import swal from "sweetalert"

const Dashboard = (props) => {
  const modules = [
    {
      logo: result,
      heading: "STD-Dashboard.label.heading.title-1",
      details: "STD-Dashboard.label.heading.title-details-1",
      redirectLinkName: "STD-Dashboard.label.heading.btn-1",
      redirectLinkTooltip: "",
      countLinkName: "STD-Dashboard.label.heading.btn-2",
      countLinkRedirection: "",
      countLinkRedirectionToolTip: "",
      redirectLink: "/forPendingServices",
      permissionModule: PERMISSON_MODULES.ABSENCE_TRACKING,
      permissionType: PERMISSION_TYPE.VIEW
    },
    {
      logo: heart,
      heading: "STD-Dashboard.label.heading.title-2",
      details: "STD-Dashboard.label.heading.title-details-2",
      redirectLinkName: "STD-Dashboard.label.heading.btn-1",
      redirectLinkTooltip:
        "Initiate a Short-term Disability Leave/Application.",
      countLinkName: "STD-Dashboard.label.heading.btn-2",
      countLinkRedirection: "/applicants",
      countLinkRedirectionToolTip: "View Active Applications",
      redirectLink: "/std",
      permissionModule: PERMISSON_MODULES.STD_FORM,
      permissionType: PERMISSION_TYPE.VIEW
    },
    {
      logo: ccmService,
      heading: "CCM-Dashboard.label.heading.title",
      details: "CCM-Dashboard.label.heading.title-details",
      redirectLinkName: "STD-Dashboard.label.heading.btn-1",
      redirectLinkTooltip:
        "Initiate a CCM Application.",
      countLinkName: "STD-Dashboard.label.heading.btn-2",
      countLinkRedirection: "/applicants",
      countLinkRedirectionToolTip: "View CCM Applications",
      redirectLink: "/ccm",
      permissionModule: PERMISSON_MODULES.CCM_FORM,
      permissionType: PERMISSION_TYPE.VIEW
    },
    {
      logo: longterm,
      heading: "STD-Dashboard.label.heading.title-3",
      details: "STD-Dashboard.label.heading.title-details-3",
      redirectLinkName: "STD-Dashboard.label.heading.btn-1",
      redirectLinkTooltip: "",
      countLinkName: "STD-Dashboard.label.heading.btn-2",
      countLinkRedirection: "",
      countLinkRedirectionToolTip: "",
      redirectLink: "/forPendingServices",
      permissionModule: PERMISSON_MODULES.LTD,
      permissionType: PERMISSION_TYPE.VIEW
    },
    {
      logo: Compensation,
      heading: "STD-Dashboard.label.heading.title-4",
      details: "STD-Dashboard.label.heading.title-details-4",
      redirectLinkName: "STD-Dashboard.label.heading.btn-1",
      redirectLinkTooltip: "",
      countLinkName: "STD-Dashboard.label.heading.btn-2",
      countLinkRedirection: "/applicants",
      // count: normalizeInput(props?.applicationCount?.workersCompensation),
      redirectLink: "/air",
      permissionModule: PERMISSON_MODULES.AIR_FORM,
      permissionType: PERMISSION_TYPE.VIEW
    },
    {
      logo: Accommodationlrg,
      heading: "STD-Dashboard.label.heading.title-5",
      details: "STD-Dashboard.label.heading.title-details-5",
      redirectLinkName: "STD-Dashboard.label.heading.btn-1",
      redirectLinkTooltip: "",
      countLinkName: "STD-Dashboard.label.heading.btn-2",
      countLinkRedirection: "/applicants",
      countLinkRedirectionToolTip: "",
      redirectLink: "/accomodation",
      permissionModule: PERMISSON_MODULES.ACMD_FORM,
      permissionType: PERMISSION_TYPE.VIEW
    },
    {
      logo: Asswssmentlrg,
      heading: "STD-Dashboard.label.heading.title-6",
      details: "STD-Dashboard.label.heading.title-details-6",
      redirectLinkName: "STD-Dashboard.label.heading.btn-1",
      redirectLinkTooltip: "",
      countLinkName: "STD-Dashboard.label.heading.btn-2",
      countLinkRedirection: "",
      countLinkRedirectionToolTip: "",
      redirectLink: "/forPendingServices",
      permissionModule: PERMISSON_MODULES.ASSESSMENTS,
      permissionType: PERMISSION_TYPE.VIEW
    },
    {
      logo: Asswssmentlrg,
      heading: "STD-Dashboard.label.heading.title-7",
      details: "STD-Dashboard.label.heading.title-details-7",
      redirectLinkName: "STD-Dashboard.label.heading.btn-1",
      redirectLinkTooltip: "",
      countLinkName: "STD-Dashboard.label.heading.btn-2",
      countLinkRedirection: "/applicants",
      countLinkRedirectionToolTip: "",
      redirectLink: "/user-list",
      permissionModule: PERMISSON_MODULES.USERS,
      permissionType: PERMISSION_TYPE.VIEW
    }
  ];

  let brokermodules = [
    {
      logo: Assessment,
      heading: "STD-Dashboard.label.Sidebar.heading.title-11",
      details: "",
      redirectLinkName: "STD-Dashboard.label.heading.btn-1",
      redirectLinkTooltip: "",
      countLinkName: "",
      countLinkRedirection: "/currentactivity",
      countLinkRedirectionToolTip: "",
      redirectLink: "/currentactivity",
      permissionModule: PERMISSON_MODULES.CURRENT_ACTIVITY,
      permissionType: PERMISSION_TYPE.VIEW
    },
    {
      logo: disability,
      heading: "STD-Dashboard.label.Sidebar.heading.title-10",
      details: "",
      redirectLinkName: "STD-Dashboard.label.heading.btn-1",
      redirectLinkTooltip: "",
      countLinkName: "",
      countLinkRedirection: "/applicants",
      countLinkRedirectionToolTip: "",
      redirectLink: "/applicants",
      permissionModule: PERMISSON_MODULES.SEARCH_BY_EMPLOYEE,
      permissionType: PERMISSION_TYPE.VIEW
    },
    {
      logo: reports,
      heading: "STD-Dashboard.label.Sidebar.heading.title-16",
      details: "",
      redirectLinkName: "STD-Dashboard.label.heading.btn-1",
      redirectLinkTooltip: "",
      countLinkName: "",
      countLinkRedirection: "/myreport",
      countLinkRedirectionToolTip: "",
      redirectLink: "/myreport",
      permissionModule: PERMISSON_MODULES.MY_REPORT,
      permissionType: PERMISSION_TYPE.VIEW
    }
  ]
  useEffect(() => {
    props.resetSelectedCompany();
    props.getAuthUserRoles(props.managersDetails.companyId);
  }, []);

  useEffect(() => {
    if (props.loginReducer.isModalNotification && props.notificationReducer && props.notificationReducer.allPendingApplications.length > 0) {
      if (props.managersDetails && props.managersDetails.roleId != USER_ROLES.ADMIN) {
        let lstPendingApplications = props.notificationReducer.allPendingApplications;
        if (!props.managersDetails.companyServices.hasSTDFormFeature)
          lstPendingApplications = lstPendingApplications.filter(x => x.applicationType !== "STD")
        if (!props.managersDetails.companyServices.hasCCMFormFeature)
          lstPendingApplications = lstPendingApplications.filter(x => x.applicationType !== "CCM")
        if (!props.managersDetails.companyServices.hasAIRFormFeature)
          lstPendingApplications = lstPendingApplications.filter(x => x.applicationType !== "AIR")
        if (!props.managersDetails.companyServices.hasACMDFormFeature)
          lstPendingApplications = lstPendingApplications.filter(x => x.applicationType !== "ACMD")

        if (lstPendingApplications.length)
          swal(props.context.t("Dashboard.Pending.You.Have") + " " + lstPendingApplications.length + " " + props.context.t("Dashboard.Pending.pending.applications"));
      }
      props.setOnLoginModalNotification(false);
    }
  }, [props.loginReducer.isModalNotification && props.notificationReducer && props.notificationReducer.allPendingApplications]);

  const openPendingApplicationModal = () => {
    props.openSetModalAction(<ApplicationPending />, MODAL_SIZE.MODAL_MD);
  };

  const onLanguageSelection = (selectedLanguage) => {
    props.languageChange(selectedLanguage);
    props.closeRemoveModal();
    history.push("/std");
  };

  const onServiceButtonClick = (path) => {
    history.push(path);
  };

  const openModal = () => {
    if (
      props?.managersDetails?.languagePreference === null ||
      props?.managersDetails?.languagePreference === "" ||
      props?.managersDetails?.languagePreference === undefined
    ) {
      props.openSetModalAction(
        <LanguageConfirmationModalPopup
          onLanguageSelection={onLanguageSelection}
        />
      );
    } else {
      props.languageChange(
        props?.managersDetails?.languagePreference
          ? PREFERED_LANGUAGE_KEYS.FrenchCanada
          : PREFERED_LANGUAGE_KEYS.EnglishUS
      );

      history.push("/std");
    }
  };



  return (
    <div className="Dashboard-service">
      <div className="service-box">
        <DisplayEmployeeName context={props.context} />
        <div className="row">
          {props.managersDetails.roleId != USER_ROLES.BROKER ? modules.map((module) => (
            <ShowForPermission module={module.permissionModule} permission={module.permissionType}>
              <div
                key={module.heading}
                className="col-12 col-sm-12 col-md-12 col-lg-4"
              >
                <div className="s-box">
                  <div className="srv-img">
                    <img src={module.logo} alt="" />
                  </div>
                  <h2>{props.context.t(module.heading)}</h2>
                  <span>{props.context.t(module.details)}</span>
                  <div>
                    {module.redirectLink !== "/std" ? (
                      <div
                        onClick={() => {
                          onServiceButtonClick(module.redirectLink);
                        }}
                        className="r-more"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title={module.redirectLinkTooltip}
                      >
                        {props.context.t(module.redirectLinkName)}
                      </div>
                    ) : (
                      <div
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title={module.redirectLinkTooltip}
                        onClick={openModal}
                        className="r-more"
                      >
                        {props.context.t(module.redirectLinkName)}
                      </div>
                    )}

                    {/* <div
                    onClick={() => {
                      onServiceButtonClick(module.countLinkRedirection);
                    }}
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title={module.countLinkRedirectionToolTip}
                    className="r-more"
                  >
                    <div className="badge badge-danger">{module.count}</div>
                    &nbsp;{props.context.t(module.countLinkName)}
                  </div> */}
                  </div>
                </div>
              </div>
            </ShowForPermission>
          )) : brokermodules.map((module) => (
            <ShowForPermission module={module.permissionModule} permission={module.permissionType}>
              <div
                key={module.heading}
                className="col-12 col-sm-12 col-md-12 col-lg-4"
              >
                <div className="s-box">
                  <div className="srv-img">
                    <img src={module.logo} alt="" />
                  </div>
                  <h2>{props.context.t(module.heading)}</h2>
                  <span>{props.context.t(module.details)}</span>
                  <div>
                    {module.redirectLink !== "/std" ? (
                      <div
                        onClick={() => {
                          onServiceButtonClick(module.redirectLink);
                        }}
                        className="r-more"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title={module.redirectLinkTooltip}
                      >
                        {props.context.t(module.redirectLinkName)}
                      </div>
                    ) : (
                      <div
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title={module.redirectLinkTooltip}
                        onClick={openModal}
                        className="r-more"
                      >
                        {props.context.t(module.redirectLinkName)}
                      </div>
                    )}

                    {/* <div
                    onClick={() => {
                      onServiceButtonClick(module.countLinkRedirection);
                    }}
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title={module.countLinkRedirectionToolTip}
                    className="r-more"
                  >
                    <div className="badge badge-danger">{module.count}</div>
                    &nbsp;{props.context.t(module.countLinkName)}
                  </div> */}
                  </div>
                </div>
              </div>
            </ShowForPermission>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
